export default __webpack_public_path__ + "static/media/green-horizontal-bars.5f737a55.svg";